import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import {
  importSupply48Data,
  listSupply48Data,
} from '@ebalance/proto/bffuser/v1/supply_48_data_service-Supply48DataService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { type InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 48点データ CSV 取込 mutation フック (プレビュー / 確定共通、dry_run で分岐)。
 *
 * D7: プレビュー (dry_run=true) は反映なし・冪等なので list を invalidate
 * する必要が無い。確定 (dry_run=false かつ applied=true) のみ list を
 * invalidate して画面データを最新化する (design §8「キャッシュ」)。
 * useInvalidatingMutation の既定 factory は req に依存した分岐ができない
 * ため、ここでは直接 useMutation を組む。
 *
 * `pages/Supply48DataCsvUpload` (専用ウィザード画面) から使う
 * `src/hooks/supply48Data/` 配置の hook (frontend/apps/ebalance/CLAUDE.md
 * 「複数ページで再利用する hook のみ共有 src/hooks/<context>/」規約の対象。
 * 過去は `pages/Supply48Data` のグリッド画面インラインモーダルからも使用して
 * いたが撤去済み、CSV 取込は専用画面に一本化)。
 */
export function useImportSupply48Data(): InvalidatingMutationResultFor<
  typeof importSupply48Data
> {
  const queryClient = useQueryClient()

  return useMutation(importSupply48Data, {
    onSuccess: (data, variables) => {
      if (variables.dryRun === false && data.applied) {
        void queryClient.invalidateQueries({
          queryKey: createConnectQueryKey({
            schema: listSupply48Data,
            cardinality: 'finite',
          }),
        })
      }
    },
  })
}
